import TawkMessengerReact from "@tawk.to/tawk-messenger-react";
    
let storage = JSON.parse(localStorage.getItem("storage")!);

    let role = storage === null ? 0 : (storage.rolId as any);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);



    let userName = storage === null ? 0 : (storage.userName as any);

    const TawkMessenger = () => {
      return null;
};

export default TawkMessenger;